import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import {
    AppBar,
    Dialog,
    DialogContent,
    IconButton,
    Theme,
    Toolbar,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAppSelector } from "@/Redux/Redux";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";
import { useTheme } from "@mui/material/styles";

interface LegendModalProps {
    open: boolean;
    handleClose: () => void;
    viewData?: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },

    submit: {
        margin: theme.spacing(3, 0, 2),
    },

    buttonProgress: {
        position: "absolute",
        top: "54%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },

    wrapper: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(2),
        position: "relative",
    },

    appBar: {
        position: "relative",
        boxShadow: "none",
    },

    title: {
        flex: 1,
    },
}));

const LegendModal: FunctionComponent<LegendModalProps> = ({
    open,
    handleClose,
                                                              viewData
}): JSX.Element => {
    const { classes } = useStyles();
    let legend = viewData?.legendList?.legends;
    const groups = [];
    const theme = useTheme();
    const { t } = useTranslation();

    const arrayForSort = [...legend];
    arrayForSort.sort((a: any, b: any) =>
        a.legendShorttext > b.legendShorttext
            ? 1
            : b.legendShorttext > a.legendShorttext
              ? -1
              : 0,
    );
    legend = arrayForSort;
    legend?.forEach((element: any) => {
        if (groups.indexOf(element.legendGroup) == -1) {
            if (element.legendGroup !== null) {
                groups.push(element.legendGroup);
            } else {
                if (groups.indexOf("undefined") == -1) {
                    groups.push("undefined");
                }
            }
        }
    });
    groups.sort((a, b) => a.localeCompare(b));

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <Typography variant="h6" className={classes.title}>
                        {t("disposition.legend")}
                    </Typography>
                    <IconButton aria-label="close" onClick={handleClose} data-testid={"closeLegend"}>
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <DialogContent style={{ textAlign: "center" }}>
                {groups.map((groupItem: any, index: number) => (
                    <React.Fragment key={"group-" + index}>
                        {
                            <div
                                style={{
                                    width: "100%",
                                    color: "#000",
                                    padding: 15,
                                    marginBottom: -20,
                                    fontWeight: "bold",
                                }}
                            >
                                <span>{groupItem}</span>
                                {legend?.map((item: any, index: number) => (
                                    <React.Fragment key={"item-" + index}>
                                        {(item.legendGroup == groupItem ||
                                            (item.legendGroup == null &&
                                                groupItem == "undefined")) && (
                                            <div
                                                style={{
                                                    width: "100%",
                                                    backgroundColor: item.color,
                                                    color: theme.palette.getContrastText(item.color),
                                                    padding: 10,
                                                    marginBottom: 15,
                                                    fontWeight: "normal",
                                                }}
                                            >
                                              <span>
                                                {item.legendShorttext || item.description}
                                              </span>
                                            </div>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        }
                    </React.Fragment>
                ))}
            </DialogContent>
        </Dialog>
    );
};

export default LegendModal;
